import type { BasicViewDataType } from '../../core/view/data-view.js';
import { viewType } from '../../core/view/data-view.js';
import { ChartSingleView } from './chart-view-manager.js';

export const chartViewType = viewType('chart');

export type ChartType = 'bar' | 'horizontal-bar' | 'line' | 'pie' | 'doughnut';
export type ChartAggregation = 'count' | 'sum' | 'avg';
export type ChartSort = 'natural' | 'desc' | 'asc';
export type ChartHeight = 'S' | 'M' | 'L';

export type ChartViewData = BasicViewDataType<
  typeof chartViewType.type,
  {
    chartType?: ChartType;
    /** Property whose values become the categories (x axis / slices). */
    categoryPropertyId?: string;
    /** Number property to aggregate; unused for `count`. */
    valuePropertyId?: string;
    aggregation?: ChartAggregation;
    sort?: ChartSort;
    height?: ChartHeight;
  }
>;

export const chartViewModel = chartViewType.createModel<ChartViewData>({
  defaultName: 'Chart View',
  dataViewManager: ChartSingleView,
  defaultData: viewManager => {
    const dataSource = viewManager.dataSource;
    const ids = dataSource.properties$.value;
    const categoryPropertyId =
      ids.find(id => {
        const type = dataSource.propertyTypeGet(id);
        return type === 'select' || type === 'multi-select';
      }) ?? ids.find(id => dataSource.propertyTypeGet(id) !== 'title');
    return {
      mode: 'chart',
      chartType: 'bar',
      categoryPropertyId,
      aggregation: 'count',
      sort: 'natural',
      height: 'M',
    };
  },
});
